<h2 mat-dialog-title>{{ 'CAMPAIGNS.UPDATE_ADDRESS_TITLE' | translate }}</h2>
<mat-dialog-content class="dialog-content">
  <glxy-alert type="error" class="alert-message">
    {{ 'CAMPAIGNS.MISSING_ADDRESS' | translate }}
  </glxy-alert>

  @defer (when !loading()) {
    <form [formGroup]="addressForm" class="address-form">
      <business-address-form-v2
        [parentForm]="addressForm"
        [addressData]="address()"
        (geoLocationChanged)="addressChanged = true"
      >
      </business-address-form-v2>
    </form>
  } @loading {
    <div class="loading-container">
      <glxy-loading-spinner></glxy-loading-spinner>
    </div>
  } @error {
    <div class="error-container">
      <glxy-alert type="error">{{ 'CAMPAIGNS.ERROR_LOADING' | translate }}</glxy-alert>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="!formIsValid() || loading()" (click)="saveAddress()">
    {{ 'CAMPAIGNS.SAVE_ADDRESS' | translate }}
  </button>
</mat-dialog-actions>
